import React, { useState } from "react";

const LEAD = [
  { code: "GDPR", region: "EU", detail: "EU GDPR. Non-EU organisations handling EU resident data usually need an Article 27 representative." },
  { code: "UK GDPR", region: "UK", detail: "UK GDPR. Organisations outside the UK handling UK resident data usually need a UK Article 27 representative." },
  { code: "FADP", region: "Switzerland", detail: "Swiss FADP. Handling Swiss resident data from abroad can trigger an Article 14 representative." },
  { code: "EU AI Act", region: "EU", detail: "EU AI Act. Non-EU providers of certain AI systems need an Article 22 authorised representative." },
];

const OTHERS = ["SOC 2", "ISO 27001", "CCPA / CPRA", "PIPEDA", "HIPAA", "Privacy Act 1988", "PDPA", "LGPD", "DPDP"];

export const FrameworkBand = ({ assumptions }) => {
  const applies = {
    GDPR: assumptions ? !!assumptions.eu_residents : true,
    "UK GDPR": assumptions ? !!assumptions.uk_residents : true,
    FADP: assumptions ? !!assumptions.swiss_residents : true,
    "EU AI Act": assumptions ? !!assumptions.uses_ai : true,
  };
  const firstApplies = LEAD.findIndex((f) => applies[f.code]);
  const [active, setActive] = useState(firstApplies >= 0 ? firstApplies : 0);

  return (
    <section className="border-t hairline" style={{ background: "#EEF2F6" }} data-testid="framework-band">
      <div className="max-w-[1240px] mx-auto px-5 lg:px-8 py-16">
        <div className="max-w-2xl">
          <span className="text-[12.5px] font-bold uppercase tracking-wide text-mutedink">Global coverage</span>
          <h2 className="mt-2 text-3xl lg:text-4xl font-bold text-asphalt">Every framework, everywhere</h2>
          <p className="mt-3 text-mutedink text-[15px] leading-relaxed">
            Representative obligations are just the start. Hover a framework to see where it applies. Our certified consultants cover the rest.
          </p>
        </div>

        <div className="mt-8 flex flex-wrap gap-2.5" data-testid="framework-lead">
          {LEAD.map((f, i) => (
            <button
              key={f.code}
              onMouseEnter={() => setActive(i)}
              onFocus={() => setActive(i)}
              onClick={() => setActive(i)}
              className={`relative px-4 py-2.5 rounded-xl border-2 text-[14px] font-bold transition-all ${active === i ? "border-aqua bg-white" : applies[f.code] ? "border-teal/60 bg-white" : "border-transparent bg-white/70 text-asphalt hover:bg-white"}`}
              data-testid={`framework-chip-${f.code.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {applies[f.code] && <span className="absolute -top-2 -right-2 text-[9px] font-bold px-1.5 py-0.5 rounded-full" style={{ background: "#FC5185", color: "#fff" }}>you</span>}
              <span className="text-asphalt">{f.code}</span>
              <span className="ml-2 text-[11px] font-medium text-mutedink">{f.region}</span>
            </button>
          ))}
        </div>

        <div className="mt-4 rounded-xl bg-white border hairline p-4 text-[14px] text-asphalt min-h-[56px] flex items-center" data-testid="framework-detail">
          {LEAD[active].detail}
        </div>

        <div className="mt-6 flex flex-wrap gap-2">
          {OTHERS.map((o) => (
            <span key={o} className="px-3 py-1.5 rounded-full bg-white/60 border hairline text-[12.5px] text-mutedink">{o}</span>
          ))}
        </div>
        <p className="mt-4 text-[12px] text-mutedink">Indicative coverage, not legal advice. We confirm what applies to you from your confirmed scope.</p>
      </div>
    </section>
  );
};
